import React from "react";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import {BASE_URL_API, MARKET_BASE_URL_API} from "../Const";
import ImageList from "@mui/material/ImageList";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import ListItem from "@mui/material/ListItem";
import {Link} from "react-router-dom";
import {BottomMenu,BackButton} from './HookUtils'
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import {BasketComponent} from "./BasketComponent";

export class AllMarketComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            marketList: [],
        }
    }

    componentDidMount() {
        fetch(BASE_URL_API + 'markets?category_id=' + this.props.child_category_id, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    this.setState({marketList: results.data})
                },
                (error) => {
                    console.log("error")
                }
            );
    }

    render() {

        return (
            <div>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        <ShoppingBasketOutlinedIcon style={{color: 'black'}}/>
                        {
                            this.state.marketList.length > 0 ?
                                <ListItemText align="center"><strong style={{
                                    fontSize: 18,
                                    overflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    color: 'black'
                                }} >{this.state.marketList[0].category.title}</strong></ListItemText>
                                : ""
                        }

                        <IconButton component={Link} to={"/search"} style={{color: 'black'}} size="large"><SearchIcon/></IconButton>

                        <IconButton style={{color: 'black'}} size="large"> <BasketComponent/></IconButton>

                        <BackButton/>
                    </ToolbarMui>

                </AppBar>
                <React.Fragment>
                    <div style={{
                        marginTop: 90,
                        marginBottom: 70,
                        padding: 12,
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        gap: 12,
                    }}>
                        {this.state.marketList.map((market) => (
                            <div key={market.id} style={{ width: 150 }}>
                                <Link to={`/market?id=${market.id}`} style={{ textDecoration: "none" }}>
                                    <Paper style={{
                                        width: 150,
                                        height: 140,
                                        backgroundImage: `url(${market.pictures.length > 0 ? MARKET_BASE_URL_API + market.pictures[0].url : "hamekara-logo.png"})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        borderRadius: 8,
                                    }} />
                                    <p style={{
                                        fontSize: 14,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        color: '#000',
                                        margin: "6px 0",
                                        textAlign: "center"
                                    }}>
                                        {market.name}
                                    </p>
                                </Link>
                            </div>
                        ))}
                    </div>
                </React.Fragment>
                <BottomMenu/>
            </div>
        );
    }
}
